export const KEY_NAME = 'user_kasldkj';
export const KEY_TOKEN = 'Tokajksdhe';
export const KEY_LANGUAGE = 'lajkashdkjahs';
